import { render } from "./admin-touch-points.svg?vue&type=template&id=39a86428"
const script = {}
script.render = render

export default script